@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../settings-page.module.less';
@import (reference) '../../../constants/spacing.module.less';

.content {
  display: flex;
  flex-direction: column;
}

.display-options-header {
  padding: @settings-page--tabbed--header--padding;
}

.key-item {
  display: flex;
  align-items: center;
  margin: 5px 0 0 15px;

  &:first-of-type {
    margin-top: 15px;
  }
}

.icon,
.key-icon {
  width: 14px;
  height: 14px;
  color: @settings-page--account-display-icon--fill-color;
  //position: absolute;
}

.permissions-icon {
  margin-left: 15px;
}

.key-icon {
  margin-right: 8px;
}

.header-override {
  border-bottom: none;

  // nesting is necessary to beat specificity of tab component
  .tab-button {
    color: var(--default--text-color--17);
  }

  .selected-tab-button {
    color: var(--default--text-color--17);
    background-color: @settings-page--tabbed--tab-panel--background-color;
    font-weight: 500;
  }
}

.body-override {
  padding: @settings-page--tabbed--tab-panel--padding;
  background-color: @settings-page--tabbed--tab-panel--background-color;
  border-top: 1px solid @settings-page--account-display-tab-body--border-color;
}

.note {
  color: @settings-page--account-display-tab-note--text-color;
}

.settings {
  max-width: 1250px;
  margin-left: 15px;
  display: grid;
  grid-template-columns: minmax(150px, min-content) minmax(300px, 3.25fr);
  grid-auto-rows: 1fr;
  align-items: center;
  row-gap: 10px;

  > label {
    white-space: nowrap;
    padding-right: 15px;
    font-size: 14px;
  }

  .setting-options {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;

    .radio-checklist {
      display: flex;
      flex-direction: row;

      :nth-child(n + 1) {
        margin-right: 5px;
      }

      :first-child {
        margin-right: 15px;
      }
    }

    .helper-text {
      padding-left: 30px;
    }
  }
}

.non-header-buffer {
  margin-top: 19px;
}

.date-format-dropdown,
.date-format-dropdown-selector {
  min-width: 225px;
}

.time-zone-dropdown,
.time-zone-dropdown-selector {
  min-width: 450px;
}

.product-type-dropdown,
.product-type-dropdown-selector {
  min-width: 325px;
}
